// extracted by mini-css-extract-plugin
export default {"container":"src-components-common-FoldableButtonView-foldable-button-view-module__containersArRU"};